import React, {
  useState,
  FormEvent,
  FormEventHandler,
  useEffect,
  useRef,
} from 'react';
import { Col, Button, Modal, Input, message as Message } from 'antd';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { store } from '../../store';
import i18n from 'i18next';

import { addReport } from '../../store/cooksprofile/actions';
import { getAppGlobalState } from '../../store/app-globals/selectors';
import { ModalSuccess } from '../layout/Modal';

import EmailSentIcon from '../../assets/images/png/email-sent.png';
import { fnCheckForRestrictedWords } from '../../constants/resctrictedWords';

export interface ReportCookState {
  reportedby: string;
  user: string;
  type: string;
}

export interface ProfileReportProps {
  reports: ReportCookState;
}

export interface ReportState {
  reportMessage: string;
}

const initReportState: ReportState = {
  reportMessage: '',
};

const GlobalModalProps = {
  icon: null,
  false: true,
  className: 'report-modal',
  okButtonProps: { style: { display: 'none' } },
};

export const closeModal = () => {
  Modal.destroyAll();
};

export const ProfileReportContent: React.FC<ProfileReportProps> = ({
  reports,
}) => {
  const { isLoading, message, hasError } = useSelector(getAppGlobalState);
  const [report, setMessage] = useState<ReportState>(initReportState);
  const isSendingReport = useRef(false);
  const handleFieldChange = (field: keyof ReportState): FormEventHandler => (
    e: FormEvent<HTMLInputElement>
  ): void => {
    setMessage({ ...report, [field]: e.currentTarget.value });
    // console.log(report.reportMessage);
  };

  const dispatch = useDispatch();

  const onPressContinue = () => {
    closeModal();
  };

  const modalSucessContent = {
    icon: null,
    false: true,
    className: 'report-modal',
    okButtonProps: { style: { display: 'none' } },
    content: (
      <ModalSuccess
        icon={EmailSentIcon}
        message={i18n.t('REPORT_MESSAGE')}
        onClick={onPressContinue}
      />
    ),
  };
  const onPressSumbit = () => {
    const addreport = {
      reportedby: reports.reportedby,
      user: reports.user,
      message: report.reportMessage,
      timeadded: new Date(),
    };

    if (fnCheckForRestrictedWords(report.reportMessage)) {
      Message.error(i18n.t('RESCTRICTED_MESSAGE'));
      return;
    }

    if (report.reportMessage !== '') {
      // console.log('sending', isLoading);
      dispatch(addReport(addreport));
      isSendingReport.current = true;
    }
  };

  const sendingReport = () => {
    if (isSendingReport.current && !isLoading && !hasError) {
      closeModal();
      Modal.info(modalSucessContent);
    }
    if (isSendingReport.current && !isLoading && hasError) {
      Message.error('Somwething went wrong');
    }
  };

  useEffect(sendingReport, [isLoading]);
  return (
    <div>
      <Col className="input-field-container">
        <Input.TextArea
          placeholder="Write a reason of reporting..."
          className="input-field"
          value={report.reportMessage}
          onChange={handleFieldChange('reportMessage')}
        />
      </Col>
      <Col span={24} className="report-button">
        <Button
          block
          type="primary"
          shape="round"
          loading={isLoading}
          onClick={onPressSumbit}
          className="send-report-button"
          style={report.reportMessage === '' ? { opacity: 0.4 } : {}}
        >
          {/* <span>Send</span> */}
          <span className="continue-button-text">
            {i18n.t(`${message}`) || i18n.t(`Send`)}
          </span>
        </Button>
      </Col>
      <Col span={24} className="report-button">
        <Button
          type="default"
          onClick={closeModal}
          className="cancel-report-button"
        >
          <span>{i18n.t(`Cancel`)}</span>
        </Button>
      </Col>
    </div>
  );
};

export const capitalize = (s: string) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const ProfileReportHandler = ({ reports }: ProfileReportProps) => {
  Modal.info({
    ...GlobalModalProps,
    title: (
      <div className="report-modal-title">
        <span>{i18n.t(`Report ${reports.type}`)}</span>
        <div className="modal-title-separator" />
      </div>
    ),
    content: (
      <Provider store={store}>
        <ProfileReportContent reports={reports} />
      </Provider>
    ),
  });
};
